export const helpEs = {
  open: 'Abrir ayuda',
  title: 'Ayuda',
  search: 'Buscar ayuda',
  noResults: 'No hay artículos de ayuda coincidentes.',
  loading: 'Cargando ayuda…',
  error: 'No se pudo cargar la ayuda.',
  retry: 'Intentar de nuevo',
  fallback: 'Este artículo aún no está disponible en su idioma.',
  allTopics: 'Todos los temas',
  related: 'Temas relacionados',
  empty: 'No hay artículos de ayuda disponibles para su rol. Puede volver a cargar el contenido.',
  translationStatus:
    '{{current}}/{{total}} artículos actuales · {{locales}} idiomas · {{fallback}} alternativas · {{stale}} obsoletos',
  categories: {
    general: 'General',
    accounting: 'Contabilidad',
    documents: 'Documentos',
    finance: 'Finanzas',
    'getting-started': 'Primeros pasos',
    manufacturing: 'Producción',
    marketing: 'Marketing',
    partners: 'Socios comerciales',
    plm: 'Desarrollo de producto',
    portal: 'Portal de clientes',
    products: 'Productos',
    questionnaires: 'Cuestionarios',
    sales: 'Ventas',
    security: 'Seguridad',
    settings: 'Configuración',
  },
} as const;
